import styled from "styled-components";

export interface Props {
  padding?: string;
}

export const Padding = styled.div`  
  padding: ${(props: Props) => `${props.padding || '25px'}`};
`;

export const ViewStyled = styled.div` 
  width: calc(100% - 90px);
  padding-left: 15px;
  padding-top: 10px;
  border-left-width: 1px;
  border-left-color: rgba(0,0,0,0.2);
  border-left-style: solid;
  min-height: 100px; 
`;

export const ViewBox = styled.div`  
  display: flex; 
  align-items: center;
  background-color: #FFF;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  padding-right: 15px;
`;

export const ViewBody = styled.div`  
  background-color: #E4E4EB;
  padding: 10px 0px;
`;
